const message = {
    result : {
        errMessageInternal      : 'Permintaan gagal, silahkan coba lagi nanti',
        errConnection           : 'Network Error',
    }
}

export default message